"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable camelcase */
const lodash_1 = __importDefault(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
exports.concentrationLimitPointerMethods = [
    {
        method: 'rampGoldmanSachs1.maxSingleObligor',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            const concentrationLimitValueType = valueConfig.valueType;
            const concentrationLoanTapeRecords = lodash_1.default.orderBy(concentrationReceivables, (receivable) => receivable.concentrationLimitFields
                .eligibleExposureLessConcentrationLimitKickouts, 'desc');
            const topObligor = concentrationLoanTapeRecords[0];
            (0, common_1.finleyAssert)(topObligor, 'should have at least one concentration record for maxSingleObligor');
            // 5/20/22 - amendment:
            // We will need to update the top single obligor for last 5 days of each calendar month
            // If the GLA of the top obligor is >$50,000,000 the concentration limit goes from 5% to 7.5%
            let finalConcentrationLimit = valueConfig.limit;
            const currDate = common_1.date.currentDateTime();
            if (currDate.day > currDate.endOf('month').day - 5 &&
                topObligor.baseFields.gla &&
                topObligor.baseFields.gla > 50000000) {
                finalConcentrationLimit = 0.075;
            }
            return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                concentrationLimit: finalConcentrationLimit,
                totalConcentrationExposure,
                concentrationReceivables: [topObligor],
                concentrationLimitValueType,
            });
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map